// customization
// - added tiktok icon

/**
 * SocialLinks component.
 * @module volto-social-settings/src/components/SocialLinks/SocialLinks
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { getSocialSettings } from 'volto-social-settings/actions/getSocialSettings';
import { Icon } from 'semantic-ui-react';
import cx from 'classnames';

// temporary fix for twitter-x icon
import VoltoIcon from '@plone/volto/components/theme/Icon/Icon';
import twitterXSvg from 'volto-social-settings/components/icons/twitter-x.svg';
import 'volto-social-settings/components/SocialLinks/socialLinks.css';

// temporary fix for tiktok icon
import tiktokSvg from '@redturtle/iovisit-theme/components/Icon/icons/tiktok.svg';

const CustomIcon = ({ icon }) => {
  if (icon === 'twitter-x') {
    return <VoltoIcon className="custom-icon" size="1rem" name={twitterXSvg} />;
  }
  if (icon === 'tiktok') {
    return <VoltoIcon className="custom-icon" size="1rem" name={tiktokSvg} />;
  }

  return <Icon name={icon} />;
};

const SocialLinks = ({ wrapperCssClass, itemCssClass }) => {
  const loading = useSelector((state) => state.socialSettings?.loadingResults);
  const socialSettings = useSelector((state) => state.socialSettings?.results);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loading && !socialSettings) {
      dispatch(getSocialSettings());
    }
  }, [dispatch]);

  return socialSettings?.length > 0 ? (
    <div className={cx('social-header', wrapperCssClass)}>
      {socialSettings.map((social) => {
        const { title, icon, url } = social;

        return (
          <a
            href={url}
            rel="noopener noreferrer"
            className={cx(itemCssClass)}
            target="_blank"
            title={title}
            key={url}
          >
            <CustomIcon icon={icon} />
          </a>
        );
      })}
    </div>
  ) : null;
};

SocialLinks.propTypes = {
  wrapperCssClass: PropTypes.string,
  itemCssClass: PropTypes.string,
};

export default SocialLinks;
